import classNames from 'classnames';
import * as React from 'react';
import { useIntl } from 'react-intl';
import css from './LowestPrice.module.scss';

interface Props {
  className?: string;
  lowestPrice: number;
  uniquePricing: boolean;
}

const LowestPrice = (props: Props) => {
  const intl = useIntl();
  return props.lowestPrice == null ? (
    <></>
  ) : (
    <span className={classNames(css.LowestPrice, props.className)}>
      <span className={css.LowestPrice__Emphasis}>
        {intl.formatNumber(props.lowestPrice)}
      </span>
      {intl.formatMessage({
        id: props.uniquePricing
          ? 'merchants.common.lowestPrice.single_unit'
          : 'merchants.common.lowestPrice.multi_unit',
      })}
    </span>
  );
};

export default LowestPrice;
